import { render } from "./StudentRequirementSubmission.vue?vue&type=template&id=93695046"
import script from "./StudentRequirementSubmission.vue?vue&type=script&lang=js"
export * from "./StudentRequirementSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__